const getPageNumberSufix = (pageNumber?: number) =>
  pageNumber ? ` - Page ${pageNumber}` : '';

export default getPageNumberSufix;
